import { ScreenBounds } from "../common/screen-bounds";
import { ScreenXY } from "../common/screen-xy";
import { PointSymbol } from "./symbol";
/**
 * 字符符号
 * @remarks
 * 中英文皆可，注意控制长度，推荐单个字符
 */
export class LetterSymbol extends PointSymbol {
    constructor() {
        super(...arguments);
        /**
         * 外圈半径
         */
        this.radius = 10;
        /**
         * 字符，中英文皆可，推荐单个字符
         */
        this.letter = "";
        /**
         * 字体颜色
         */
        this.fontColor = "#ff0000";
        /**
         * 字体大小
         */
        this.fontSize = 12;
        /**
         * 字体
         */
        this.fontFamily = "YaHei";
        /**
         * 字体粗细
         */
        this.fontWeight = "Bold";
    }
    /**
     * 绘制字符符号
     * @param {CanvasRenderingContext2D} ctx - 绘图上下文
     * @param {ScreenXY} screenXY - 屏幕坐标
     */
    draw(ctx, screenXY) {
        ctx.save();
        ctx.strokeStyle = this.strokeStyle;
        ctx.fillStyle = this.fillStyle;
        ctx.lineWidth = this.lineWidth;
        ctx.beginPath(); //Start path
        //keep size
        // ctx.setTransform(1, 0, 0, 1, 0, 0);
        //绘制外圈
        ctx.arc(screenXY.x, screenXY.y, this.radius, 0, Math.PI * 2, true);
        ctx.fill();
        ctx.stroke();
        ctx.textBaseline = "middle";
        ctx.textAlign = "center";
        ctx.fillStyle = this.fontColor;
        ctx.font = this.fontSize + "px/1 " + this.fontFamily + " " + this.fontWeight;
        //绘制字符
        ctx.fillText(this.letter, screenXY.x, screenXY.y);
        ctx.restore();
    }
    /**
     * 获取包络矩形
     * @param {ScreenXY} screenXY - 屏幕坐标
     */
    getScreenBounds(screenXY) {
        let r = this.radius, w = this.stroke ? this.weight / 2 : 0, p = new ScreenXY(r + w, r + w);
        return new ScreenBounds(screenXY.subtract(p), screenXY.add(p));
    }
}
